module.exports = __webpack_public_path__ + "img/Launchpad-dark.2e079239.svg";